import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const LoaderSpinner = ({children, isLoading}) => {

    return isLoading
        ? <div
            className="py-5 d-flex justify-content-center align-items-center"
            style={{minWidth: "200px", minHeight: "300px"}}
        >
            <FontAwesomeIcon
                icon="circle-notch"
                spin
                size="5x"
                className="fa-spin mb-4 text-primary"
            />
        </div>
        : children;
};

export default LoaderSpinner;